import { InfiniteDataQueryFnUtils } from '../../../../../hooks/useInfiniteDataQuery/utils/useInfiniteDataQueryFn.utils';
import { UseInfiniteListWithCheckboxParams } from '../../../../../hooks/useInfiniteListWithCheckbox/useInfiniteListWithCheckbox.types';
import { findCatalogs } from '../../../../../services/modules/catalogs/catalogs.repository';
import { FindCatalogsOutput } from '../../../../../services/modules/catalogs/catalogs.repository.types';
import { catalogsRepositoryOfflineAdapters } from '../../../../offline/offlineRequestAdapters/catalogs.repository.offlineAdapters';
import { Catalog } from '../../../catalog.types';
import { CATALOG_LIST_FILTERS_KEYS } from '../../../filter/catalogListFilter.utils';

export const catalogListFetcherWithStatusCounts: UseInfiniteListWithCheckboxParams<Catalog>['queryFn'] =
  async (context) => {
    const response = await InfiniteDataQueryFnUtils.defaultFetcher<
      FindCatalogsOutput,
      typeof findCatalogs
    >(findCatalogs)(context);

    return {
      data: response.data,
      countData: {
        total: response.count || 0,
        facets: response.statusCounts,
      },
    };
  };

export const offlineCatalogListFetcher: UseInfiniteListWithCheckboxParams<Catalog>['queryFn'] =
  async ({ limit, skip, params }) => {
    const { data, count } = await catalogsRepositoryOfflineAdapters.list({
      limit,
      skip,
      query: params?.[CATALOG_LIST_FILTERS_KEYS.query] as string | undefined,
    });

    return {
      data,
      countData: { total: count },
    };
  };
